export const teutonicResearch = [
    { name: "Spearman", wood: 970, clay: 380, iron: 880, crop: 400, all: 2630 },
    { name: "Axeman", wood: 880, clay: 580, iron: 1560, crop: 580, all: 3600 },
    { name: "Scout", wood: 1060, clay: 500, iron: 600, crop: 460, all: 2620 },
    { name: "Paladin", wood: 2320, clay: 1180, iron: 2520, crop: 610, all: 6630 },
    { name: "Teutonic Knight", wood: 2800, clay: 2160, iron: 4040, crop: 640, all: 9640 },
    { name: "Ram", wood: 6100, clay: 1300, iron: 3000, crop: 580, all: 10980 },
    { name: "Catapult", wood: 5500, clay: 4900, iron: 5000, crop: 520, all: 15920 },
    { name: "Chief", wood: 18250, clay: 13500, iron: 20400, crop: 16480, all: 68630 }
]